import axios, { AxiosRequestConfig } from 'axios';
import { message } from 'antd';
import { baseUrl, wxArticleUrl ,aiWriterUrl} from '../util/base';
import { getCookie } from './util';

const $http = axios.create({
  baseURL: baseUrl,
});
const token = getCookie('U2AT');
const defaultconfig: AxiosRequestConfig = {
  headers: {
    token: token,
  },
  withCredentials: true,
}; // 添加请求头
export const get = (url: string, params?: Record<string, any>) => {
  params = params || {};
  return new Promise((resolve, reject) => {
    // axiso 自带 get 和 post 方法
    $http
      .get(url, { params, ...defaultconfig })
      .then((res) => {
        if (res.data.code === '200') {
          resolve(res.data);
        } else {
          if (res.data.code === '4000') {
            if (res.data.data && res.data.data.loginUrl) {
              // document.cookie = 'returnUrl=' + window.location.origin + ';domain=xdf.cn;path=/';

              // document.cookie = 'returnUrl=https:' + baseUrl + url + ';domain=xdf.cn;path=/';
              window.location.href = res.data.data.loginUrl+'&returnUrl=' + encodeURIComponent(window.location.href);;
            }
          }
          message.error(res.data.message);
          reject(res.data.message);
        }
      })
      .catch((error) => {
        reject(error);
        message.error('请稍后重试');
      });
  });
};

export const post = (url: string, params: any, uconfig?: any) => {
  params = params || {};
  const config = { ...defaultconfig, ...uconfig };

  return new Promise((resolve, reject) => {
    $http
      .post(url, params, config)
      .then((res: any) => {
        if (res.data.code === '200') {
          resolve(res.data);
        } else {
          message.error(res.data.message);
          reject(res.data.message);
        }
      })
      .catch((error) => {
        // reject(error);
        message.error('请稍后重试');
      });
  });
};

/**
 * 通用的post生成器
 * 可以定制返回内容的interface及接口成功的判断标准
 * T: 返回的类型
 * U: 返回值的字段的名字，方便后面生成的函数重定义这个内容
 *  */
function createGet<T, U extends string>(baseURL: string, resolveFn: (result: T) => boolean) {
  return function <Data = any>(
    url: string,
    params?: Record<string, any>,
  ): Promise<Record<U, Data> & Omit<T, U>> {
    params = params || {};
    return new Promise((resolve, reject) => {
      $http
        .get(url, { params, baseURL, ...defaultconfig })
        .then((res) => {
          if (resolveFn(res.data)) {
            resolve(res.data);
          } else {
            message.error(res.data.message);
            reject(res.data.message);
          }
        })
        .catch((error) => {
          reject(error);
          message.error('请稍后重试');
        });
    });
  };
}
/**
 * 通用的post生成器
 * 可以定制返回内容的interface及接口成功的判断标准
 * T: 返回的类型
 * U: 返回值的字段的名字，方便后面生成的函数重定义这个内容
 *  */
function createPost<T, U extends string>(baseURL: string, resolveFn: (result: T) => boolean) {
  return function <Data = any>(
    url: string,
    params: Record<string, any>,
    uconfig?: AxiosRequestConfig,
  ): Promise<Record<U, Data> & Omit<T, U>> {
    params = params || {};
    const config = { ...defaultconfig, baseURL, ...uconfig };

    return new Promise((resolve, reject) => {
      $http
        .post(url, params, config)
        .then((res) => {
          if (resolveFn(res.data)) {
            resolve(res.data);
          } else {
            message.error(res.data.message);
            reject(res.data.message);
          }
        })
        .catch((error) => {
          // reject(error);
          message.error('请稍后重试');
        });
    });
  };
}

/**
 * 给微信公众号做的
 * 为啥要新建一个：不同团队开发的，返回的结构不一样，判断成功的标准不一样
 * 通过status判断是否请求成功
 */
export const postForWxArtical = createPost<API.RwxArtical<any>, 'data'>(
  wxArticleUrl,
  (res) => res.status === 200,
);

export const getForWxArtical = createGet<API.RwxArtical<any>, 'data'>(
  wxArticleUrl,
  (res) => res.status === 200,
);


export const postForChatGpt = createPost<API.RwxArtical<any>, 'data'>(
  aiWriterUrl,
  (res) => res.status === 200,
);

export const getForChatGpt = createGet<API.RwxArtical<any>, 'data'>(
  aiWriterUrl,
  (res) => res.status === 200,
);
